/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Destination_UnavailableInputs */

const en_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t find the destination for this deposit. Try again in a moment.`)
};

const de_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ziel für diese Einzahlung konnte nicht gefunden werden. Versuchen Sie es gleich noch einmal.`)
};

const pt_br2_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível encontrar o destino deste depósito. Tente novamente em instantes.`)
};

const tr_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu para yatırma işleminin hedefini bulamadık. Birazdan tekrar deneyin.`)
};

const zh_cn2_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们找不到本次存入的目标账户，请稍后重试。`)
};

const zh_hk2_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們找不到今次存入的目的地，請稍後再試。`)
};

const ko_kr2_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 입금의 도착지를 찾을 수 없습니다. 잠시 후 다시 시도해 주세요.`)
};

const ru_ru2_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось найти адрес назначения для этого пополнения. Повторите попытку через мгновение.`)
};

const es_419_deposit_error_destination_unavailable = /** @type {(inputs: Deposit_Error_Destination_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos el destino de este depósito. Inténtalo de nuevo en un momento.`)
};

/**
* | output |
* | --- |
* | "We couldn’t find the destination for this deposit. Try again in a moment." |
*
* @param {Deposit_Error_Destination_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_destination_unavailable = /** @type {((inputs?: Deposit_Error_Destination_UnavailableInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Destination_UnavailableInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_destination_unavailable(inputs)
	if (locale === "de") return de_deposit_error_destination_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_destination_unavailable(inputs)
	if (locale === "tr") return tr_deposit_error_destination_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_destination_unavailable(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_destination_unavailable(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_destination_unavailable(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_destination_unavailable(inputs)
	return es_419_deposit_error_destination_unavailable(inputs)
});